export default "__VITE_ASSET__COOyAR6s__"